import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { ROLE_HOME } from "../../lib/gmaoConstants";
import GmaoLayout from "../gmao/GmaoLayout";

const ProtectedRoute = ({ allow }) => {
  const { user } = useAuth();

  // En cours de vérification de session
  if (user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-slate-50"
        data-testid="auth-loading"
      >
        <Loader2 className="w-8 h-8 animate-spin text-[hsl(207,78%,42%)]" />
      </div>
    );
  }

  // Non authentifié
  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  // Mauvais rôle → rediriger vers l'espace de l'utilisateur
  if (allow && !allow.includes(user.role)) {
    return <Navigate to={ROLE_HOME[user.role] || "/login"} replace />;
  }

  return (
    <GmaoLayout>
      <Outlet />
    </GmaoLayout>
  );
};

export default ProtectedRoute;
